import React from 'react'
// import { initStore } from '../store'
// import { bindActionCreators } from 'redux';
// import withRedux from 'next-redux-wrapper';
import { connect } from 'react-redux';
// import { compose } from 'recompose';
import PropTypes from 'prop-types';

import AppCustomLink from '../../components/Common/AppCustomLink';
// import Link from 'next/link';
import { cdnApi, podcastTypes, firestoreApi } from '../../lib/utils';
import { fetchTopChartsPodcasts, fetchTopChartsEpisodes } from '../../actions';
// import { fetchUserSubscriptions } from '../actions/PodcastActions';

import { NextSeo } from 'next-seo';
// import FireStoreParser from 'firestore-parser';
// import Router from 'next/router';
import TopCharts from '../../components/Common/TopCharts';

// const types = { 'podcasts': '0', 'episodes': '1' };

// export async function getStaticPaths() {
//     // Get the paths we want to pre-render based on posts
//     try {
//         const paths = [];
//         console.log('in topCharts id');
//         podcastTypes.forEach(podcastType => {
//             if (podcastType.id !== 'All') {
//                 paths.push(`/top-charts/${podcastType.id}`);
//             }
//         });
//         console.log('paths');
//         console.dir(paths);

//         // We'll pre-render only these paths at build time.
//         // { fallback: false } means other routes should 404.
//         return { paths, fallback: true }
//     } catch (err) {
//         console.error(err);
//     }
// }
// export async function getStaticProps({ params }) {
//     const podcastTypeId = params && params.id;
//     const genreId = podcastTypeId || 'All'; //.replace('-and-', ' & ');
//     // try {
//     const results = await Promise.all([fetchTopChartsPodcasts(genreId, 1), fetchTopChartsEpisodes(genreId, 1)]);
//     let finalJsonArray = results[0];
//     let finalJsonArrayEpisodes = results[1];
//     return { props: { podcastsArray: finalJsonArray, episodesArray: finalJsonArrayEpisodes, podcastTypeId: genreId } };
//     // } catch {
//     //     throw new Error("Api call didn't return any data.");
//     //     // return { podcastsInfo: {}, podcastTypeId };
//     // }
// }

class Browse extends React.Component {
    static async getInitialProps(context) {
        const podcastTypeId = context.query.id;
        console.dir(podcastTypeId);
        const genreId = podcastTypeId || '0'; //.replace('-and-', ' & ');
        console.dir(genreId);
        // try {
        let results = [[], []];
        if (podcastTypeId != 'for-you') {
            results = await Promise.all([fetchTopChartsPodcasts(genreId, 1), fetchTopChartsEpisodes(genreId, 1)]);
        }
        let finalJsonArray = results[0];
        let finalJsonArrayEpisodes = results[1];
        console.dir(results);
        return { podcastsArray: finalJsonArray, episodesArray: finalJsonArrayEpisodes, podcastTypeId: genreId };
        // } catch {
        //     throw new Error("Api call didn't return any data.");
        //     // return { podcastsInfo: {}, podcastTypeId };
        // }
    }

    constructor(props) {
        super(props);
        // this.state = {
        //   hasMorePodcasts: true, hasMoreEpisodes: true, podcastsArray: props.podcastsArray,
        //   episodesArray: props.episodesArray, boxShadow: '', forceRenderEpisodes: true
        // };
    }

    render() {
        const { podcastTypeId } = this.props;
        const { podcastsArray, episodesArray } = this.props;

        const currentPodcastType = podcastTypes.find((el) => el.id == podcastTypeId) || { 'name': '' };

        let titleSEO;
        let descriptionSEO;
        let canonicalSEO;
        if (podcastTypeId == 'All') {
            titleSEO = 'Top Books';
            descriptionSEO = 'Discover the best Books to listen to while running, at work or any other time.';
            canonicalSEO = 'https://tedapp.ai/top-charts';
        } else {
            titleSEO = `Top Books: ${currentPodcastType.name}`;
            descriptionSEO = `Discover the best ${currentPodcastType.name} Books to listen to while running, at work or any other time.`;
            canonicalSEO = `https://tedapp.ai/top-charts/${podcastTypeId}`;
        }

        console.dir(podcastTypeId);
        return (
            <div>
                {podcastTypeId != 'for-you' && <NextSeo
                    title={titleSEO}
                    description={descriptionSEO}
                    canonical={canonicalSEO}
                    openGraph={{
                        title: titleSEO,
                        description: descriptionSEO,
                        type: 'website',
                        locale: 'en_IE',
                        url: canonicalSEO,
                        images: [{
                            url: 'https://tedapp.ai/explore/static/images/home/1.png',
                            alt: 'Best podcast player for all devices - web, ios, android, windows and mac OS',
                            width: 922,
                            height: 1209,
                        }],
                        site_name: 'Accelerated',
                    }}
                    twitter={{
                        handle: '@tedapp',
                        site: '@tedapp',
                        cardType: 'summary',
                    }}
                />}

                <TopCharts podcastsArray={podcastsArray} episodesArray={episodesArray} podcastTypeId={podcastTypeId} />
            </div>
        );
    }
}

Browse.propTypes = {
    podcastsArray: PropTypes.array,
    episodesArray: PropTypes.array,
    podcastTypeId: PropTypes.string
}


export default connect(null, null)(Browse);
